import { Link } from 'react-router-dom'
import { Check } from 'lucide-react'
import { PageMeta } from '../components/seo/PageMeta'
import { Button } from '../components/ui/Button'
import { SwitchingFaq } from '../components/shared/SwitchingFaq'
import { pageMeta } from '../lib/seo'
import { pricingSchema } from '../lib/schema'

const included = [
  'Unlimited support — no ticket limits',
  '24/7 monitoring & proactive issue resolution',
  'Software licensing included',
  'Cloud migration and setup',
  'Device management (Mac, PC, mobile)',
  'Anti-virus, backups, security patching',
  'Hardware procurement at cost',
  'Strategic IT roadmapping',
  'AI automation consultation',
]

export default function Pricing() {
  return (
    <>
      <PageMeta
        title={pageMeta.pricing.title}
        description={pageMeta.pricing.description}
        canonical={pageMeta.pricing.canonical}
        schema={pricingSchema}
      />
      <main className="min-h-screen pt-24 pb-16 px-6">
        <section className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="font-display font-black text-4xl md:text-5xl uppercase text-white mb-6">
            Simple pricing. No surprises.
          </h1>
          <p className="font-body text-cream-dim text-lg">
            One flat monthly rate covers everything your team needs. No hourly billing, no ticket limits, no hidden fees.
          </p>
        </section>

        <section className="max-w-xl mx-auto mb-20">
          <div
            className="p-10 rounded-xl border-2 shadow-xl"
            style={{ backgroundColor: 'var(--bg-3)', borderColor: 'var(--accent)' }}
          >
            <p className="font-display font-black text-5xl mb-2" style={{ color: 'var(--accent)' }}>
              $219
            </p>
            <p className="font-body text-cream-dim mb-8">Per Employee, Per Month</p>
            <ul className="space-y-3 mb-8">
              {included.map((item) => (
                <li key={item} className="flex items-center gap-3 font-body text-cream-dim">
                  <Check className="w-5 h-5 shrink-0" style={{ color: 'var(--accent)' }} />
                  {item}
                </li>
              ))}
            </ul>
            <Button to="/contact" variant="primary" fullWidth>
              Book a Free Discovery Call
            </Button>
            <p className="font-body text-cream-dim text-sm mt-6 text-center">
              Pricing scales with your team. A team of 10 = ~$2,190/month.
            </p>
          </div>
        </section>

        <section className="max-w-xl mx-auto text-center mb-16 p-6 rounded-lg" style={{ backgroundColor: 'var(--bg-3)' }}>
          <p className="font-body text-cream-dim mb-4">
            Not sure what you're currently spending on IT?
          </p>
          <Link to="/#calculator" className="font-body font-medium" style={{ color: 'var(--accent)' }}>
            Run the numbers →
          </Link>
        </section>

        <SwitchingFaq />

        <section className="max-w-4xl mx-auto text-center mt-16">
          <Button to="/contact" variant="primary">
            Book Your Free Discovery Call
          </Button>
        </section>
      </main>
    </>
  )
}
export { Pricing as Component }
